import React, {useEffect} from 'react';
import {createRoot} from "react-dom/client";
import PublicationsList from "./components/publicationsList/publicationsList";
import PublicationsFacets from "./components/publictionFacets/publicationsFacets";
import PublicationsPaginator from "./components/publicationsPaginator/publicationsPaginator";
import PublicationsSearchField from "./components/publicationsSearchField/publicationsSearchField";

import "./publications.scss";
import '../i18n';
import i18next from "i18next";

const facetsLookup = [
    'series',
    'recurrence_supplement',
    'recurrence_addendum',
    'recurrence_amendment',
    'recurrence_revision',
    'recurrence_volume',
    'recurrence_issue',
    'recurrence_part',
    'recurrence_number',
    'recurrence_session',
    'recurrence_year',
    'recurrence_year_range',
    'recurrence_edition',
    'recurrence_symbol',
    'authors',
    'publishers',
    'publication_date',
    'theme_nuclear_disarmament_non_proliferation',
    'theme_biological_chemical_weapons',
    'theme_conventional_weapons',
    'theme_regional_disarmament',
    'theme_emerging_cross_cutting_other_issues',
    'theme_gender_perspectives_disarmament_arms_control',
    'theme_disarmament_machinery',
    'theme_information_outreach'
];

const rootElement = document.getElementById("publications-list");
const queryString = rootElement.getAttribute("data-queryString")
const searchUri = rootElement.getAttribute("data-search-uri");
const root = createRoot(document.getElementById("publications-list"));

const _parseQueryString = (queryString) => {
    let params = new URLSearchParams(queryString);
    const qPage = params.get('page') || 1;
    const sTerm = params.get('searchTerm') || '';
    const qFields = params.getAll('queryFields') || ['publication_title'];
    let qFacets = {};
    facetsLookup.forEach((facet) => {
        if (params.has(facet)) {
            qFacets[facet] = params.get(facet);
        }
    });
    return {qPage, sTerm, qFields, qFacets};
}

function _reduceFacets(facets) {
    let acc = '';
    Object.entries(facets).forEach((key, value) => {
        acc += '&'+key[0]+'='+key[1];
    });
    return acc;
}

function _reduceSearchFields(queryFields, searchTerm) {
    let acc = '';
    queryFields.forEach((field) => {
        acc += '&'+field+'='+searchTerm;
    });
    return acc;
}


const PublicationSearch = ({queryString, searchUri}) => {

    const lang_code = i18next.language;

    const { qPage, sTerm, qFields, qFacets } = _parseQueryString(queryString);

    const [searchTerm, setSearchTerm] = React.useState(sTerm ?? '*')
    const [page, setPage] = React.useState(qPage);
    const [queryFields, setQueryFields] = React.useState(qFields)
    const [facets, setFacets] = React.useState(qFacets);
    const [searchResults, setSearchResults] = React.useState([]);
    const [searchFacets, setSearchFacets] = React.useState({});
    const [searchPaginator, setSearchPaginator] = React.useState({});

    const handleFacetChanged = (facetChangeEvent) => {
        let currentFacets = {...facets};
        if (facetChangeEvent.facet_entry.selected) {
            console.log('adding facet')
            currentFacets[facetChangeEvent.facet_key] = facetChangeEvent.facet_entry.facet;
        } else {
            console.log('removing facet')
            delete currentFacets[facetChangeEvent.facet_key];
        }
        setPage(1);
        setFacets(currentFacets);
    }
    const handlePageChanged = (apage) => {
        setPage(apage);
    }
    const handleSearch = (asearchTerm) => {
        asearchTerm === '' ? setSearchTerm('*') : setSearchTerm(asearchTerm);
        setPage(1);
    }

    const getPublications = async (page, lang_code, facets, queryFields, searchTerm) => {

        const facetString = _reduceFacets(facets)
        const searchFieldString = _reduceSearchFields(queryFields, searchTerm)

        const url = `${searchUri}/api/v2/pages/?page=${page}&size=10&lang_code=${lang_code}`+searchFieldString+facetString;
        const response = await fetch(url,
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Access-Control-Allow-Origin': '*'
                },
            });
        return response.json();
    }

    useEffect(() => {

        getPublications(page, lang_code, facets, queryFields, searchTerm)
            .then(
                data => {
                    console.log(data)
                    setSearchResults(data["items"]);
                    setSearchFacets(data["facets_expanded"]);
                    setSearchPaginator(data["paginator"]);
                })
            .catch(
                error => {console.log(error)}
            );
    }, [page, lang_code, facets, queryFields, searchTerm]);

    return (
        <div>
            <div className={'py-5'}>
                <PublicationsSearchField
                onSearch={handleSearch}
                ></PublicationsSearchField>
            </div>
            <div className={'d-flex flex-row'}>
                <div className={'col d-flex flex-column justify-content-start'}>
                    <h4>{searchPaginator.total_count} {i18next.t('publications.publications_found', 'publications found')}</h4>
                    <div className={'d-flex flex-column justify-content-between h-100'}>
                        <PublicationsList
                            props={{results: searchResults}}>
                        </PublicationsList>
                        <PublicationsPaginator
                            paginator={searchPaginator}
                            onPaginate={handlePageChanged}
                        ></PublicationsPaginator>
                    </div>
                </div>
                <div id={'facets-sidebar'} className={'col col-md-3 facets-sidebar publication-sidebar offcanvas offcanvas-end'} tabindex="-1" data-bs-scroll="true" data-bs-backdrop="false">
                    <h4>{i18next.t('publications.filter_by', 'Filter by')}</h4>
                    <PublicationsFacets
                        searchFacets={searchFacets}
                        onFacetChanged={handleFacetChanged}>
                    </PublicationsFacets>
                </div>
            </div>
        </div>
    )
}

export default PublicationSearch;

root.render(
    <React.StrictMode>
        <PublicationSearch queryString={queryString} searchUri={searchUri}/>
    </React.StrictMode>
);

